/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Create_DescriptionInputs */

const en_settings_apikeys_create_description = /** @type {(inputs: Settings_Apikeys_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give your key a name to identify it later`)
};

/**
* | output |
* | --- |
* | "Give your key a name to identify it later" |
*
* @param {Settings_Apikeys_Create_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_create_description = /** @type {((inputs?: Settings_Apikeys_Create_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Create_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_create_description(inputs)
});
export { settings_apikeys_create_description as "settings.apikeys.create_description" }